import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1, Small, Subhead1} from '@adv-mt/ui/typography'

import BaseDrawer from '../BaseDrawer/index.js'
import {BASE_CLASS, getDrawerConfig, getRanks, LITERAL_KEYS} from './config.js'
import Indicator from './Indicator.js'

const PriceIndicatorDrawer = ({ad = {}, onClose}) => {
  const {domain, i18n} = useSuiContext()
  const config = domain.get('config')

  const {offerType = {}, price, priceAverageIndicator, priceRankIndicator} = ad

  const ranks = getRanks(config.get('priceIndicator'))
  const highlightedIndex = ranks.findIndex(({value}) => value === priceRankIndicator)

  if (highlightedIndex < 0) return null

  const {averageLabelKey, comparisonKeyPrefix, descriptionSuffixKey, hasAverage, legalTextKeys} = getDrawerConfig({
    offerTypeId: offerType.id,
    offerTypes: config.get('search')
  })

  const {label, value} = ranks[highlightedIndex]

  return (
    <BaseDrawer onClose={onClose} title={i18n.t(LITERAL_KEYS.TITLE)}>
      <div className={BASE_CLASS}>
        <Subhead1 as="h3">{i18n.t(LITERAL_KEYS.HEADLINE, {rank: label.toLowerCase()})}</Subhead1>

        <Body1>
          {i18n.t(LITERAL_KEYS.DESCRIPTION_PREFIX)}{' '}
          <Body1 as="strong" highlight>
            {i18n.t(`${comparisonKeyPrefix}${value}`)}
          </Body1>{' '}
          {i18n.t(descriptionSuffixKey)}
        </Body1>

        <Indicator
          average={hasAverage ? priceAverageIndicator : undefined}
          averageLabel={averageLabelKey && i18n.t(averageLabelKey)}
          highlightedIndex={highlightedIndex}
          price={price}
          ranks={ranks}
        />

        <div className={`${BASE_CLASS}-legal`}>
          <Icon size={ICON_SIZES.SM}>
            <IconInfoOutline size={ICON_SIZES.SM} />
          </Icon>
          <div className={`${BASE_CLASS}-legalTexts`}>
            {legalTextKeys.map(legalTextKey => (
              <Small key={legalTextKey}>{i18n.t(legalTextKey)}</Small>
            ))}
          </div>
        </div>
      </div>
    </BaseDrawer>
  )
}

PriceIndicatorDrawer.displayName = 'PriceIndicatorDrawer'

PriceIndicatorDrawer.propTypes = {
  ad: PropTypes.shape({
    offerType: PropTypes.shape({id: PropTypes.number}),
    price: PropTypes.number,
    priceAverageIndicator: PropTypes.number,
    priceRankIndicator: PropTypes.number
  }),
  onClose: PropTypes.func.isRequired
}

export default PriceIndicatorDrawer
